<script lang="ts">
  import DeleteImportantRessource from "@kontextwerk/control-web-frame/components/danger/DeleteImportantRessource.svelte"
  import type { PageContext } from "../../context"

  const { pageContext } = $props<{ pageContext: PageContext }>()
</script>

{#if pageContext.organization && pageContext.canDeleteOrganization}
  <div data-testid="controlAdmin.organizationDangerZone.tab">
    <DeleteImportantRessource
      title="Organisation löschen"
      description="Die Organisation wird zur Löschung vorgemerkt, aktive Sitzungen werden beendet und alle zugehörigen Daten werden im Hintergrund dauerhaft entfernt. Dieser Schritt kann von niemandem rückgängig gemacht werden."
      resourceName={pageContext.organization.name}
      actionLabel="Organisation löschen"
      errorMessage="Organisation konnte nicht gelöscht werden."
      brightBackground={true}
      testIdPrefix="controlAdmin.organizationDangerZone.deleteOrganization"
      onConfirm={async () => {
        await pageContext.onDeleteOrganization()
      }}
    />
  </div>
{/if}
